export const WHATSAPP_NUMBER = "6281234567890"; // placeholder — replace with the studio's real WhatsApp number

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
